import { tPatientModel } from './tPatientModel';
import { tConsultDetailModel, tConsultDetailV2Model } from './tConsultDetailModel';
import { StringValueToken } from 'html2canvas/dist/types/css/syntax/tokenizer';

export class tConsultHeadModel {

    shopID: string;

    clthConsultNumber: string;
    clthArrivalDateTime: Date;
    clthPatientID: string;

    clthBookNumber: string;
    clthBillingStatus: string;


    clthPrescripNumber: string;
    clthBillingNumber: string;
    clthBedNumber: number;
    clthDiagonsis: string;
    clthDetailDesc: string;
    clthFollowUpDesc: string;
    clthRequestServiceName: string;
    clthRequestTherapistName: string;
    clthAuxName: string;
    clthRemark: string;
    clthFollowUp: string;

    clthTherapistID: string;
    clthTherapistName: string;

    inActive: string;
    lastModifyDatetime: Date;
    lastModifyUserID: string;


    remark1: string;
    remark2: string;
    remark3: string;
    remark4: string;
    remark5: string;


    isPrintDeposit: string;
depositTotal: string;
depositPaid: string;
depositBalance: string;
}


export class tConsultHeadModelWithPatientInfo extends tConsultHeadModel {

    patientID: string;
    patientTypeID: string;
    pTypeDesc: string;
    patientTitle: number;
    patientGender: number;
    patientChiName: string;
    patientSurname: string;
    patientFirstName: string;
    phoneAreaCode: string;
    patientPhone: number;
    patientPhone2: number;
    patientMedCard1: string;
    patientMedCard2: string;
    patientIHKID: string;
    patientDob: Date;
    patientRefereeEmp: string;
    patientRefereePat: string;
    patientRefereeRelation: string;
    patientAddress: string;
    patientEmail: string;
    patientRemark1: string;
    patientRemark2: string;
    patientRemark3: string;
    patientDepositAcct: number;
    patientChangeAcct: number;

    patientKnowFromMedium: string;
    billRemaining: number;

    bedDesc: string;

    tConsultDetailInfo: tConsultDetailV2Model[];
    prescriptionConsultData:prescriptionConsultData[];
    prescriptionHeaderCount: number;

    consultFinalAmt: number;

    prescriptionHeaderFinalAmt: number;

    patientDiseaseMapModels: patientDiseaseMapModel[];

    patientDIseaseRemark1: string;
    patientOtherInfo1:string;
    clthTherapistName:string;

    clthHeight:Number;
    clthWeight:Number;
    clthSystolic:string;
    clthDiastolic:string;
    clthBreathingPerMin:Number;
    clthPulsePerMin:Number;
    clthTemperature:Number;
    clthOxygen:Number;
    patientBloodType:Number;
}
export class tConsultHeadLogModel extends tConsultHeadModelWithPatientInfo{
  isSaveRemark:boolean;
  isSaveConsultRemark:boolean;
  staffRemark:string;
}
export class tConsultHeadModelWithPatientInfoV3 extends tConsultHeadModelWithPatientInfo{
  clthCaseDrID:string;
  canChangeCaseDr:boolean;
  canChangeTreatDr:boolean;
}

export class tConsultHeadModelWithPatientInfoV4 extends tConsultHeadModelWithPatientInfoV3{
  patientHKID:string;
  hkidDesc:string;
}

export class tConsultHeadModelWithPatientInfoV2 extends tConsultHeadModelWithPatientInfo{
    bookingTime:string;
    clthCaseDrID:string;
    clthCaseDrName:string;
    clthTherapistID:string;

}

export class patientDiseaseMapModel {
    patientID: string;
    pDiseaseType: string;
    diseaseID: string;
    diseaseDesc: string;
    diseaseDescEng: string;
    diseaseWarning: string;

}

export class tConsultHeadModelWithPatientInfo_Billing extends tConsultHeadModelWithPatientInfo {
    shopID: string;
    bpDateTime: Date;
    bpConsultNumber: string;
    bpInvoiceNumber: string;
    clthPrescripNumber: string;
    clthPrescripNumberArray: string[];
    paymentNumber: string;
    voidPaymentNumber: string;
    billPayAmount:number;
    diagnosis: string;
    clthDetailDesc: string;
    isSaveRemark:boolean;
    isSaveConsultRemark:boolean;
}



export class BillPayStatus {
    static WaitingAction = 'WaitingAction';
    static ReadyPayment = 'ReadyPayment';
    static FinishPayment = 'Completed';
    static ReadyPaymentChange='ReadyPaymentChange';
}

export class VoidVoucherListClass {
    shopID: string;
    clthArrivalDateTime: Date;
    clthConsultNumber: string;
    clthPatientID: string;
    clthBookNumber: string;
    clthPrescripNumber: string;
    clthBillingNumber: string;
    clthBillingDateTime: Date;
    clthBillingStatus: string;
    inActive: string;
    paymentNumber: string;

    patientChiName: string;
    patientSurname: string;
    patientFirstName: string;
    patientPhone: number;
    patientPhone2: number;

    patientID: string;
    patientMedCard1: string;

    clthPrescripNumberArray: string[];
    tConsultDetailInfo: tConsultDetailModel[];
    clthTherapistName:string;
    clthTherapistID:string;
}

export class VoidVoucherListClassV2 extends VoidVoucherListClass {
  changeAcc: ChangeAccModel;
  paymentDateTime:Date;
  paidAmount:Number;
}

export class ChangeAccModel {
  changeID:string;
  changeName:string;
}

export class backDayHistoryListClass {
    shopID: string;
    clthArrivalDateTime: Date;
    clthConsultNumber: string;
    clthPatientID: string;
    clthBookNumber: string;
    clthPrescripNumber: string;
    clthBillingNumber: string;
    clthBillingDateTime: Date;
    clthBillingStatus: string;
    clthBookingTime:string;
    inActive: string;
    paymentNumber: string;
    paymentNumbers: string[];
    clthDiagonsis:string;
    patientChiName: string;
    patientSurname: string;
    patientFirstName: string;
    patientPhone: number;
    patientPhone2: number;

    patientID: string;
    patientMedCard1: string;

    clthPrescripNumberArray: string[];
    tConsultDetailInfo: tConsultDetailModel[];
    clthTherapistName:string;
    clthTherapistID:string;
    amountTotal:number;
    outstandingAmount:number;
}


export class prescriptionConsultData {
    consultNumber:string;
    feeItemDesc:string;
    feeAmt:number;
    prescriptionItemType:number;
    prescriptionDays:number;
    prescriptionitemFinalUnitAmt:number;
    prescriptionQuantity:number;
}

export interface getHistoryBackDaySearchV3Model{
  paymentDate: string;
  paymentNumber: string;
  invoiceNumber: string;
  clthConsultNumber:string;
  paidAmount: number;
  outstandingAmount: number;
  patient: HistoryBackDaySearchV3Patient;
  consultation: HistoryBackDaySearchV3Consultation;
  
}
export interface HistoryBackDaySearchV3Consultation {
  clthConsultNumber: string;
  clthDiagonsis: string;
  prescriptions:string[];
  changeAcc:{changeID:string;changeName:string;};
}
export interface HistoryBackDaySearchV3Patient {
  patientID: string;
  patientChiName: string;
}

export interface TotalCtTodayResponse{
  patient:any;
  consults:any[];
}
